import {
  CommonModule,
} from '@angular/common';
import {
  NgModule,
} from '@angular/core';
import {
  OrderStoreModule,
} from '@des/store/order';
import {
  OrderEligibilitiesStoreModule,
} from '@des/store/order-eligibilities';
import {
  RefundTeaserPresModule,
} from '../presenter/custom-refund-teaser-pres.module';
import {
  CustomRefundTeaserContComponent,
} from './custom-refund-teaser-cont.component';

@NgModule({
  imports: [CommonModule, OrderEligibilitiesStoreModule, OrderStoreModule, RefundTeaserPresModule],
  declarations: [CustomRefundTeaserContComponent],
  exports: [CustomRefundTeaserContComponent]
})
export class CustomRefundTeaserContModule {}
